import MainConnection from "./MainConnection";

export default {
  requestClientList: async function() {
    try {
      const requestURL = "/client/all";
      const response = await MainConnection.request().get(requestURL);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestClientInfoById: async function(client_id) {
    try {
      const requestURL = "/client/" + client_id;
      const response = await MainConnection.request().get(requestURL);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  }
};
